import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType } from '@ngx-formly/core';
import { NotificationService } from '../../../@core/services/notification/notification.service';
import { AssetInput } from '../../../generated/generated-types';
import { AssetService } from '../../asset/services/asset.service';
import { WidgetAssetPreviewComponent } from '../../asset/widget-asset-preview/widget-asset-preview.component';

@Component({
  selector: 'app-formly-asset-widget',
  imports: [
    WidgetAssetPreviewComponent,
  ],
  templateUrl: './formly-asset-widget.component.html',
  host: {
    class: 'block w-full',
  },
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
/**
 * put in whole asset in formly definition (key: featuredAsset eg)
 */
export class FormlyAssetWidgetComponent extends FieldType {

  constructor(
    private assetService: AssetService,
    private notificationService: NotificationService,
  ) {
    super();
  }

  get fileAccept(): string | undefined {
    const accept = this.props.accept;
    return typeof accept === 'string' && accept.length > 0 ? accept : undefined;
  }

  get previewClass(): string | undefined {
    const previewClass = this.props.previewClass;
    return typeof previewClass === 'string' && previewClass.length > 0 ? previewClass : undefined;
  }

  async onFilesSelected(files: File[]): Promise<void> {

    if (!this.model?.id) {
      this.notificationService.error(_("error.save-first"));
      return
    }

    if (files?.length) {

      let file = files[0];

      if (this.fileAccept) {
        if (!this.fileMatchesAccept(file, this.fileAccept)) {
          this.notificationService.error(_('error.file-type-not-supported'));
          return;
        }
      } else if (!this.isImageFile(file)) {
        this.notificationService.error(_('error.file-type-not-supported'));
        return;
      }

      const compressedImage = await this.assetService.resizeImageIfNeeded(file);
      if (compressedImage) {
        file = compressedImage;
      }
      const input: AssetInput = {
        file: file,
        name: file.name,
      };
      const asset = await this.assetService.saveAsset(input);
      this.formControl.setValue(asset);
      //should we set id here somehow too?

      if (!this.props.skipNotification) {
        this.notificationService.success(_("common.save-successful"));
      }
    } else {

      this.formControl.setValue(null);
    }
  }

  private isImageFile(file: File): boolean {
    const mime = (file.type ?? '').toLowerCase();
    if (mime.startsWith('image')) {
      return true;
    }
    if (mime.length === 0) {
      return this.assetService.isImageFileByExtension(file.name);
    }
    return false;
  }

  private fileMatchesAccept(file: File, accept: string): boolean {
    const tokens = accept.split(',').map((token) => token.trim().toLowerCase()).filter(Boolean);
    if (tokens.length === 0) {
      return true;
    }

    const mime = (file.type ?? '').toLowerCase();
    const name = (file.name ?? '').toLowerCase();

    return tokens.some((token) => {
      if (token.startsWith('.')) {
        return name.endsWith(token);
      }
      if (token.endsWith('/*')) {
        return mime.startsWith(token.slice(0, -1));
      }
      return mime === token;
    });
  }
}
